export var BUY_SELL_LAYOUTS = {
  PRICE_PER_UNIT: 'PRICE_PER_UNIT',
  AMOUNT_FOR_PRICE: 'AMOUNT_FOR_PRICE'
};